import { observer } from 'mobx-react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import security from 'stores/security';
import Page from './Page';

/**
 * 升级react-router v6后从open下单独抽取出来
 * 保持原有功能：已登录跳转/open，未登录正常注册
 */
const Signup: React.FC = () => {
    const { isLogin } = security;
    const location = useLocation();

    return (
        <div className="signup-root">
            <Routes>
                {!isLogin ? (
                    <>
                        <Route path=":regType?" element={<Page />} />
                        <Route
                            path="*"
                            element={
                                <Navigate
                                    replace
                                    state={location.state}
                                    to={{
                                        ...location,
                                        pathname: '.'
                                    }}
                                />
                            }
                        />
                    </>
                ) : (
                    <Route path="*" element={<Navigate replace to={{ ...location, pathname: '/open' }} />} />
                )}
            </Routes>
        </div>
    );
};

export default observer(Signup);
